// @flow
import type { Dispatch } from '..';

export type SetSearchRadiusAction = {
  type: 'SEARCH_RADIUS_SET',
  radius: string,
  didUserChange: boolean
};

export type Action = SetSearchRadiusAction;

export const setSearchRadiusFunction = (
  radius: string,
  didUserChange: boolean
) => ({ type: 'SEARCH_RADIUS_SET', radius, didUserChange });

export const setSearchRadius = (radius: string, didUserChange: boolean) => (
  dispatch: Dispatch
) => {
  dispatch(setSearchRadiusFunction(radius, didUserChange));
};
